var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfemail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 320 320)",
    id: "Y6qT7XXobzb5rEmT7APAL"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.8 63.48)",
    id: "2plWiH-HOYTo3sk5DJG1l"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-246.91, -332.24)",
    d: "M 23.942 215.16 C 21.863 213.668 19.123 213.464 16.846 214.633 C 14.569 215.801 13.137 218.146 13.137 220.705 C 13.137 267.646 13.137 422.762 13.137 422.762 C 13.137 422.762 13.396 443.873 42.128 451.752 L 448.767 451.752 C 448.767 451.752 481.009 444.763 480.678 419.841 L 480.678 218.603 C 480.678 216.409 479.454 214.399 477.506 213.391 C 475.558 212.383 473.21 212.546 471.42 213.813 C 432.336 241.479 282.85 347.293 282.85 347.293 L 208.045 347.293 C 208.045 347.293 64.866 244.532 23.942 215.16 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 0.91 -2.03 -68.14)",
    id: "X_8zLdtTZzXBnPiPAiOhg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-248.3, -198.85)",
    d: "M 19.091 153.162 L 19.091 108.9 C 19.091 108.9 27.891 84.569 52.222 83.534 L 443.073 83.534 C 443.073 83.534 476.722 87.157 477.499 114.853 L 477.499 152.385 C 477.499 152.385 319.91 283.71 288.701 309.717 C 285.241 312.6 281.012 314.161 276.663 314.161 C 262.197 314.161 228.153 314.161 213.098 314.161 C 208.316 314.161 203.674 312.4 199.919 309.161 C 168.406 281.975 19.091 153.162 19.091 153.162 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99 0 0 0.86 -137.13 -43.8)",
    id: "DUI5PxEiIeNE2HiCSsuFj"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(132,24,38)",
      strokeWidth: 1.08,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-112.39, -206.12)",
    d: "M 207.01 295.395 C 207.01 295.395 39.382 167.703 20.385 134.396 C 1.388 101.088 92.5 125.419 92.5 125.419 L 207.01 295.395 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.98 0 0 0.88 131.54 -41.36)",
    id: "woN5-xAEBMRR71FzeFvUk"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(132,24,38)",
      strokeWidth: 1.07,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-385.09, -206.27)",
    d: "M 288.526 287.076 C 288.066 288.064 288.262 289.274 289.001 290.018 C 289.741 290.762 290.837 290.852 291.665 290.236 C 323.584 266.611 454.792 168.458 478.793 133.619 C 506.161 93.893 343.868 167.922 343.868 167.922 C 343.868 167.922 301.674 258.768 288.526 287.076 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfemail);
export default __webpack_public_path__ + "static/media/ffemail.d01e39aabec04eba4356f02cdb41d88b.svg";
export { ForwardRef as ReactComponent };